import moment from 'moment'

import {cdnPrefix} from '../filters'

exports.productCover = (productSerialId) => {
  if (productSerialId) {
    return cdnPrefix(`product-${productSerialId.substr(4)}-cover.jpg`)
  }
  return ''
}

exports.productCoverInError = (e) => {
  let src = e.target.src
  if (src) {
    console.log('%c[Review-productCoverInError]', 'color: #63ADD1', 'onerr')
    e.target.src = src.replace('.jpg', '_.jpg')
  }
}

exports.dateFormat = (date) => {
  return moment(date).format('YYYY-MM-DD')
}

function inActivityDateRange () {
  let startDate = new Date(2019, 9, 21)
  let endDate = new Date(2019, 10, 11)
  let inDateRange = moment().isAfter(startDate) && moment().isBefore(endDate);
  return inDateRange
}

exports.inActivityDateRange = inActivityDateRange

exports.inReduceActivity = (product) => {
  // 急速商标 满减活动
  if (![
    'BJBJLD0023', 'GDSZLD0023', 'HNZZLD0023', 'JSNJLD0023', 'JSSZLD0023', 'JSZJLD0023', 'SCCDLD0023', 'SHSHLD0023'
  ].includes(product.serialId)) {
    return false;
  }
  let inDateRange = inActivityDateRange()
  return inDateRange && !!product.discountPrice && product.discountPrice !== 0
}



// WEBPACK FOOTER //
// ./src/utils/index.js